import React from 'react';
import { baseXUnit } from '../../styles/theme';

const HorizontalList: React.FunctionComponent<{
  children?: React.ReactNode;
}> = ({ children, ...rest }) => {
  return (
    <div className="horizontal-list" {...rest}>
      {React.Children.map(children, (child) => {
        return child;
      })}
      {/*language=CSS*/}
      <style jsx>{`
        .horizontal-list {
          overflow-x: scroll;
          white-space: nowrap;
          -ms-overflow-style: none; // IE 10+
          scrollbar-width: none; // Firefox
        }
        .horizontal-list::-webkit-scrollbar {
          display: none; // Safari and Chrome
        }
        .horizontal-list:first-child {
          padding-left: ${baseXUnit(2)};
        }
        .horizontal-list:last-child {
          padding-right: ${baseXUnit(2)};
        }
      `}</style>
    </div>
  );
};

export default HorizontalList;
